module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('router-link', {
    staticClass: "big-btn red",
    attrs: {
      "to": {
        path: '/admin/pick'
      }
    }
  }, [_vm._v("\n        Add Picks\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn blue",
    attrs: {
      "to": {
        path: '/admin/picks'
      }
    }
  }, [_vm._v("\n        Manage Picks\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn orange",
    attrs: {
      "to": {
        path: '/admin/record'
      }
    }
  }, [_vm._v("\n        Manage Record\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn black",
    attrs: {
      "to": {
        path: '/admin/testimonial'
      }
    }
  }, [_vm._v("\n        Add Testimonials\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn black",
    attrs: {
      "to": {
        path: '/admin/testimonials'
      }
    }
  }, [_vm._v("\n        Manage Testimonials\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn red",
    attrs: {
      "to": {
        path: '/admin/posts/0'
      }
    }
  }, [_vm._v("\n        Add Blog Post\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn green",
    attrs: {
      "to": {
        path: '/admin/posts'
      }
    }
  }, [_vm._v("\n        Manage Blog Posts\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn blue",
    attrs: {
      "to": {
        path: '/admin/users'
      }
    }
  }, [_vm._v("\n        Manage Users\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn black",
    attrs: {
      "to": {
        path: '/admin/package'
      }
    }
  }, [_vm._v("\n        Manage Packages\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn orange",
    attrs: {
      "to": {
        path: '/admin/categories'
      }
    }
  }, [_vm._v("\n        Manage Categories\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "big-btn black",
    on: {
      "click": function($event) {
        _vm.clearCache()
      }
    }
  }, [_vm._v("\n        Clear Cache\n      ")])], 1), _vm._v(" "), (_vm.admin) ? _c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "widget"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n              Overall: "), _c('b', [_vm._v(_vm._s(_vm.admin["overall"]) + " members")])]), _vm._v(" "), _c('p', [_vm._v("\n              Free: "), _c('b', [_vm._v(_vm._s(_vm.admin["free"]) + " members"), _c('b')])]), _vm._v(" "), _c('p', [_vm._v("\n              All Sports: "), _c('b', [_vm._v(" " + _vm._s(_vm.admin["all"]) + " members")])]), _vm._v(" "), _c('p', [_vm._v("\n              NFL: "), _c('b', [_vm._v(" " + _vm._s(_vm.admin["nfl"]) + " members")])]), _vm._v(" "), _c('p', [_vm._v("\n              NCAAF: "), _c('b', [_vm._v(" " + _vm._s(_vm.admin["ncaaf"]) + " members")])]), _vm._v(" "), _c('p', [_vm._v("\n              NBA: "), _c('b', [_vm._v(" " + _vm._s(_vm.admin["nba"]) + " members")])]), _vm._v(" "), _c('p', [_vm._v("\n              NCAAB: "), _c('b', [_vm._v(" " + _vm._s(_vm.admin["ncaab"]) + " members")])]), _vm._v(" "), _c('p', [_vm._v("\n              MLB: "), _c('b', [_vm._v(" " + _vm._s(_vm.admin["mlb"]) + " members")])]), _vm._v(" "), _c('p', [_vm._v("\n              NHL: "), _c('b', [_vm._v(" " + _vm._s(_vm.admin["nhl"]) + " members")])])])])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h5', [_vm._v("Members")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5f6234c5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Admin.vue
// module id = 506
// module chunks = 1